"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePassport = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var inputs_component_1 = require("../../components/inputs.component");
var interpolate_1 = require("../../utils/interpolate/interpolate");
var ajax_util_1 = require("../../utils/ajax/ajax.util");
var constants_1 = require("../../constants");
var form_hooks_1 = require("../../utils/forms/form-hooks");
var pp_react_1 = require("@paypalcorp/pp-react");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS;
var passport_1 = require("../../actions/passport");
var passport_2 = require("../../utils/passport");
var commonweb_utils_1 = require("commonweb-utils");
var page = require("page");
/**
 * TODO: move validation and form specific changes in HOC
 */
exports.UpdatePassport = function (props) {
    var initializer = function () {
        var passportContent = props.content.passport, countryOptionLabel = {
            optionId: "",
            optionValue: passportContent.issuingCountry.label,
        }, countryOptions = [countryOptionLabel].concat(props.passport.countryOptionList || []), selectedCountryOption = countryOptions.find(function (countryOption) {
            return countryOption.optionValue ==
                props.passport.passportCountry;
        }) || countryOptionLabel;
        return {
            form: {
                passportNumberInput: {
                    elementType: "input",
                    elementConfig: {
                        type: "text",
                        label: passportContent.passport.label,
                        suggestionText: passportContent.passport.error,
                    },
                    value: "",
                    validation: {
                        required: true,
                    },
                    isValid: false,
                    isTouched: false,
                },
                passportCountryInput: {
                    elementType: "select",
                    elementConfig: {
                        options: countryOptions,
                        placeholder: passportContent.issuingCountry.label,
                        suggestionText: "",
                    },
                    value: selectedCountryOption.optionId,
                    validation: {
                        required: true,
                    },
                    isValid: !!selectedCountryOption.optionId,
                    isTouched: !!selectedCountryOption.optionId,
                },
            },
            formIsValid: false,
            formMessage: "",
        };
    };
    var submitHandle = function () {
        var formData = {}, form = inputs.form;
        for (var formElementIdentifier in form) {
            formData[formElementIdentifier] = form[formElementIdentifier].value;
        }
        if (!inputs.formIsValid) {
            setFormMessage(props.content.passport.edit.passportError);
            return;
        }
        ajax_util_1.default.post$(props.dispatch, props._csrf, "" + ROUTES.API.PASSPORT.UPDATE, formData, { component: { name: VIEWS.UPDATE_PASSPORT } })
            .then(function (passportInfo) {
            if (passportInfo) {
                props.dispatchPassportChange(passportInfo);
            }
            page.redirect(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PASSPORT.UPDATE_SUCCESS);
        })
            .catch(function (error) {
            var errorStatusCode = commonweb_utils_1.objectUtils.safeGet(error, "error.statusCode") || 500;
            if (errorStatusCode >= 400 && errorStatusCode < 500) {
                setFormMessage(props.content.passport.edit.passportError);
            }
            else {
                setFormMessage(props.content.passport.genericError);
            }
            return;
        });
    };
    var getForm = function () {
        var formElementsArray = [];
        var showSpinner = props.ui.showSpinner, passportInfo = props.passport, passportContent = props.content.passport;
        for (var key in inputs.form) {
            formElementsArray.push({
                id: key,
                config: inputs.form[key],
            });
        }
        var form = (React.createElement("form", { onSubmit: submitHandler },
            inputs.formMessage ? (React.createElement(pp_react_1.Alert, { id: "test_error_alert", type: "error", className: "form-alert" }, inputs.formMessage)) : null,
            React.createElement(pp_react_1.Text, { size: "xl3", className: "generic-header passport-header" }, passportContent.edit.header),
            passportInfo.passportNumber && (React.createElement(pp_react_1.Text, { className: "generic-message noTopPadding", size: "lg" }, interpolate_1.default("inHTMLData", passportContent.edit.passportInfo, {
                passportNumber: passportInfo.passportNumber,
            }))),
            formElementsArray.map(function (formElement) { return (React.createElement(inputs_component_1.default, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, value: formElement.config.value, isInvalid: !formElement.config.isValid, shouldValidate: formElement.config.validation, isTouched: formElement.config.isTouched, changed: function (event) {
                    return inputChangedHandler(event, formElement.id);
                } })); }),
            React.createElement(pp_react_1.Button, { id: "test_update_passport", className: "passport-button", name: "passportUpdateSubmit", type: "submit" }, props.content.common.next),
            React.createElement(pp_react_1.Link, { id: "test_remove", href: "/", onClick: passport_2.onClickRemovePassport }, props.content.common.remove)));
        return (React.createElement("div", { className: "generic-container" }, showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "panelSpinnerNew", size: "lg" })) : (form)));
    };
    var _a = form_hooks_1.default(initializer(), submitHandle), inputs = _a.inputs, inputChangedHandler = _a.inputChangedHandler, submitHandler = _a.submitHandler, setFormMessage = _a.setFormMessage;
    return getForm();
};
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account;
    var passport = commonweb_utils_1.objectUtils.safeGet(account, "passport") || {};
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        passport: passport,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchPassportChange: function (passportInfo) {
            return dispatch(passport_1.changePassport(passportInfo));
        },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.UpdatePassport);
